import { render } from "./Payment2xOptions.vue?vue&type=template&id=25bd1f5b"
import script from "./Payment2xOptions.vue?vue&type=script&lang=js"
export * from "./Payment2xOptions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__